import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCountryNetwork,
  getCountryNetworkRequestSaga,
  setMktpReturnFeature,
  setRdReturnFeature,
  updateMktpReturnFeatureRequestSaga,
  updateRdReturnFeatureRequestSaga,
} from 'domains/countryNetwork/CountryNetwork.store';
import { Box, Flex, Text } from 'UI';
import { Switch } from 'UI/Switch';

const CountryNetwork = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const countryNetwork = useSelector(getCountryNetwork);

  useEffect(() => {
    dispatch(getCountryNetworkRequestSaga());
  }, [dispatch]);

  const handleToggleRd = (enabled: boolean) => {
    dispatch(setRdReturnFeature(enabled));
    dispatch(updateRdReturnFeatureRequestSaga({ isEnabled: enabled }));
  };

  const handleToggleMktp = (enabled: boolean) => {
    dispatch(setMktpReturnFeature(enabled));
    dispatch(updateMktpReturnFeatureRequestSaga({ isEnabled: enabled }));
  };

  const justifySpaceBetween = 'space-between';

  return (
    <>
      <Box height={60} />
      <Text type={'h1'}>{t('backoffice.country_network.return_feature.title', 'Return feature')}</Text>
      <Text type="base">
        {t(
          'backoffice.country_network.return_feature.description',
          'Allows the country to manage the return of car parts from the network to R1',
        )}
      </Text>
      <Box height={30} />
      <Text type="base">
        {t(
          'backoffice.country_network.return_feature.description.detail',
          'As a country administrator, you can control whether customers are allowed to return items purchased through the platform.',
        )}
      </Text>
      <Box height={30} />
      <Flex direction={'column'} justify={justifySpaceBetween} padding={20}>
        <Flex direction={'column'} justify={justifySpaceBetween}>
          <Text type="heading4">
            {t('backoffice.country_network.return_feature.rd.title', 'Returns for Renault / Dacia Products')}
          </Text>
          <Box height={5} />
          <Flex justify={justifySpaceBetween}>
            <Text type="base">
              {t(
                'backoffice.country_network.return_feature.rd.description',
                'The network will be able to return R&D car parts to R1.',
              )}
            </Text>
            <Switch
              checked={countryNetwork.returnFeature.returnRdEnabled}
              onChange={handleToggleRd}
              data-cy={'return-rd-switch'}
            />
          </Flex>
        </Flex>
        <Box height={30} />
        <Flex direction={'column'} justify={justifySpaceBetween}>
          <Text type="heading4">
            {t('backoffice.country_network.return_feature.mktp.title', 'Returns for Marketplace Products')}
          </Text>
          <Box height={5} />
          <Flex justify={justifySpaceBetween}>
            <Text type="base">
              {t(
                'backoffice.country_network.return_feature.mktp.description',
                'The network will be able to return MKTP car parts to R1.',
              )}
            </Text>
            <Switch
              checked={countryNetwork.returnFeature.returnMktpEnabled}
              onChange={handleToggleMktp}
              data-cy={'return-mktp-switch'}
            />
          </Flex>
        </Flex>
      </Flex>
      <Box height={60} />
    </>
  );
};

export default CountryNetwork;
